var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,15 C3.65493333,15 0.933333333,12.2784 0.933333333,8.93333333 C0.933333333,5.58826667 3.65493333,2.86666667 7,2.86666667 C9.83033333,2.86666667 12.1333333,5.16966667 12.1333333,8 C12.1333333,10.8308 9.83033333,13.1333333 7,13.1333333 C4.68393333,13.1333333 2.8,11.2494 2.8,8.93333333 C2.8,6.61726667 4.68393333,4.73333333 7,4.73333333 C8.80086667,4.73333333 10.2666667,6.19913333 10.2666667,8 C10.2666667,9.80086667 8.80086667,11.2666667 7,11.2666667 C5.7134,11.2666667 4.66666667,10.2204 4.66666667,8.93333333 C4.66666667,7.6472 5.7134,6.6 7,6.6 C7.77186667,6.6 8.4,7.22813333 8.4,8 C8.4,8.77186667 7.77186667,9.4 7,9.4 L7,8.46666667 C7.25713333,8.46666667 7.46666667,8.25713333 7.46666667,8 C7.46666667,7.74286667 7.25713333,7.53333333 7,7.53333333 C6.22813333,7.53333333 5.6,8.16146667 5.6,8.93333333 C5.6,9.7052 6.22813333,10.3333333 7,10.3333333 C8.2866,10.3333333 9.33333333,9.28706667 9.33333333,8 C9.33333333,6.71386667 8.2866,5.66666667 7,5.66666667 C5.19913333,5.66666667 3.73333333,7.13246667 3.73333333,8.93333333 C3.73333333,10.7342 5.19913333,12.2 7,12.2 C9.31606667,12.2 11.2,10.3160667 11.2,8 C11.2,5.68393333 9.31606667,3.8 7,3.8 C4.16966667,3.8 1.86666667,6.103 1.86666667,8.93333333 C1.86666667,11.7641333 4.16966667,14.0666667 7,14.0666667 C10.3450667,14.0666667 13.0666667,11.3450667 13.0666667,8 C13.0666667,4.65493333 10.3450667,1.93333333 7,1.93333333 L7,1 C10.8598,1 14,4.13973333 14,8 C14,11.8602667 10.8598,15 7,15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollup);
export default __webpack_public_path__ + "static/media/rollup.628a007b768355232fa11b7179eab084.svg";
export { ForwardRef as ReactComponent };